import { FC, ReactNode, forwardRef } from "react"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import DialogActions from "@mui/material/DialogActions"
import Slide from "@mui/material/Slide"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import { TransitionProps } from "@mui/material/transitions"
import { Breakpoint } from "@mui/material"
import * as styles from "./styles"

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />
})

type RelendDialogProps = Record<`data-${string}`, any> & {
  open: boolean
  handleClose: () => void
  children: ReactNode
  title?: string
  showCloseButton?: boolean
  maxWidth?: Breakpoint
  buttons?: JSX.Element
}

const View: FC<RelendDialogProps> = ({
  open,
  handleClose,
  children,
  title,
  showCloseButton = true,
  maxWidth = "sm",
  buttons,
  ...props
}) => {
  return (
    <Dialog
      {...props}
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby='alert-dialog-slide-description'
      sx={styles.dialogWrapper}
      maxWidth={maxWidth}
      fullWidth
    >
      {title && <DialogTitle sx={styles.dialogTitle}>{title}</DialogTitle>}
      {showCloseButton && (
        <IconButton aria-label='close' className='sm:top-3' onClick={handleClose} sx={styles.dialogIconClose}>
          <CloseIcon />
        </IconButton>
      )}

      <DialogContent sx={styles.dialogContent}>{children}</DialogContent>
      {buttons && <DialogActions sx={styles.dialogActions}>{buttons}</DialogActions>}
    </Dialog>
  )
}

export default View
